<script lang="ts">
  import { Eye } from "lucide-svelte";

  export let title = "Impacted Users";
  export let users: string[] = [];
  export let revealed = false;

  let showAll = false;
  const displayCount = 8;
  $: visibleUsers = showAll ? users : users.slice(0, displayCount);
  $: hasMore = users.length > displayCount;

  function toggleReveal() {
    revealed = !revealed;
  }

  $: obfuscateEmail = (email: string) => {
    if (!revealed) {
      const [username, domain] = email.split("@");
      return `${username.charAt(0)}${"*".repeat(username.length - 2)}${username.charAt(username.length - 1)}@${domain}`;
    }
    return email;
  };
</script>

<div class="rounded-lg border bg-white">
  <div class="p-4 border-b">
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2">
        <h3 class="text-base font-medium text-gray-900">{title}</h3>
        <span class="rounded-full bg-purple-100 px-2.5 py-0.5 text-xs font-medium text-purple-700">
          {users.length} users
        </span>
      </div>
      <button on:click={toggleReveal} class="inline-flex items-center gap-1 text-sm text-gray-500 hover:text-gray-700">
        <Eye size={16} />
        {!revealed ? "Reveal emails" : "Hide emails"}
      </button>
    </div>
  </div>

  <div class="divide-y">
    {#each visibleUsers as user}
      <div class="p-4 text-sm text-gray-600">
        {obfuscateEmail(user)}
      </div>
    {/each}
  </div>

  {#if hasMore && !showAll}
    <div class="p-4 border-t">
      <button on:click={() => (showAll = true)} class="w-full text-center text-sm text-gray-500 hover:text-gray-700">
        Show more
      </button>
    </div>
  {/if}

  {#if showAll}
    <div class="p-4 border-t">
      <button on:click={() => (showAll = false)} class="w-full text-center text-sm text-gray-500 hover:text-gray-700">
        Show less
      </button>
    </div>
  {/if}
</div>
